import { SwipeGamesItem } from '../model/swipe';

export class GameGridManager {
  private readonly icons: SwipeGamesItem[] = [];
  private onGameGridClick?: (gameIndex: number, gameId: string) => void;

  constructor(icons: SwipeGamesItem[]) {
    this.icons = icons;
  }

  public setOnGameGridClick(
    callback: (gameIndex: number, gameId: string) => void,
  ): void {
    this.onGameGridClick = callback;
  }

  public populateGameGrid(): void {
    const gameGrid = document.querySelector('.game-grid');
    if (!gameGrid) return;

    gameGrid.innerHTML = this.generateGameGridHTML();
    this.updateGameCount();
  }

  private generateGameGridHTML(): string {
    return this.icons
      .map(
        (game, index) => `
      <div class="game-item" data-game-index="${index}" data-game-id="${game.gameId}">
        <img src="${game.gameIconUrl}" alt="${game.displayName || 'Game'}">
        <span>${game.displayName || 'Game'}</span>
      </div>
    `,
      )
      .join('');
  }

  private updateGameCount(): void {
    const gameCountElement = document.querySelector('#swipe-game-counts');
    if (gameCountElement) {
      gameCountElement.textContent = `${this.icons.length} games`;
    }
  }

  public initializeGameGrid(): void {
    const gameGrid = document.querySelector('.game-grid');
    if (!gameGrid) return;

    for (const gameItem of Array.from(
      gameGrid.querySelectorAll('.game-item'),
    )) {
      gameItem.addEventListener('click', (event: Event) => {
        this.handleGameGridClick(event);
      });
    }
  }

  private handleGameGridClick(event: Event): void {
    const gameItem = (event.currentTarget as HTMLElement).closest('.game-item');
    if (!gameItem) return;

    const gameIndex = parseInt(gameItem.getAttribute('data-game-index') || '0');
    const gameId = gameItem.getAttribute('data-game-id') || '';

    this.onGameGridClick?.(gameIndex, gameId);
  }

  public updateGameGridSelection(selectedIndex: number): void {
    const gameGrid = document.querySelector('.game-grid');
    if (!gameGrid) return;

    let index = 0;
    for (const item of Array.from(gameGrid.querySelectorAll('.game-item'))) {
      item.classList.toggle('selected', index === selectedIndex);
      item.classList.remove('active');
      index++;
    }
  }

  public closeDrawer(): void {
    const drawer = document.querySelector('.swipe-sdk-drawer');
    const overlay = document.querySelector('.drawer-overlay');

    if (drawer?.classList.contains('open')) {
      drawer.classList.remove('open');
      drawer.classList.add('closing');
      overlay?.classList.remove('open');
      setTimeout(() => {
        drawer.classList.remove('closing');
      }, 300);
    }
  }

  public getGameCount(): number {
    return this.icons.length;
  }
}
